import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { content, getRelatedContent } from "../../data/content";
import { scrollToElement } from "../../utils/scrollHelper";
import PreviewCard from "./PreviewCard";
import SkillCard from "./SkillCard";
import SkillBar from "./SkillBar";
import "../../styles/Skills.scss";

const Skills = () => {
  const navigate = useNavigate();
  const [activeSkill, setActiveSkill] = useState(null);
  const skillsRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (skillsRef.current && !skillsRef.current.contains(event.target)) {
        setActiveSkill(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleLinkClick = async (e, link) => {
    e.stopPropagation();
    const [path, id] = link.split("#");

    if (window.location.pathname !== path) {
      await navigate(link);
      setTimeout(() => scrollToElement(id), 100);
    } else {
      scrollToElement(id);
    }
  };

  const handleSkillClick = (skillId) => {
    setActiveSkill((currentSkill) =>
      currentSkill === skillId ? null : skillId,
    );
  };

  return (
    <div className="skills" ref={skillsRef}>
      <section className="skills__hero">
        <h1>Skills</h1>
        <p>Technical expertise, leadership, and collaboration</p>
      </section>
      <div className="skills__grid">
        {content.skills.map((category, idx) => (
          <SkillCard
            key={idx}
            category={category}
            idx={idx}
            activeSkill={activeSkill}
            onToggleSkill={handleSkillClick}
            PreviewCard={PreviewCard}
            SkillBar={SkillBar}
            getRelatedContent={getRelatedContent}
            onLinkClick={handleLinkClick}
          />
        ))}
      </div>
    </div>
  );
};

export default Skills;
